import {
  PRESUPUESTADOR_LOAD_ITEM_NUEVO_BEGIN,
  PRESUPUESTADOR_LOAD_ITEM_NUEVO_SUCCESS,
  PRESUPUESTADOR_LOAD_ITEM_NUEVO_FAILURE,
  PRESUPUESTADOR_LOAD_ITEM_NUEVO_DISMISS_ERROR,
} from './constants'

import { getEndpoint } from '../../common/backend/endpoints'
import { BFFAgent } from '../../../common/BFFAgent'
import axios from 'axios'

export function loadItemNuevo(id, datos_frizados) {
  return (dispatch, getState) => {

    const {presupuestador = {}, common:{ user }} = getState()
    const { license } = user
    // optionally you can have getState as the second argument
    dispatch({
      type: PRESUPUESTADOR_LOAD_ITEM_NUEVO_BEGIN,
    })

    const endpoint = getEndpoint('PRODUCTO')

    const promise = new Promise((resolve, reject) => {
      const doRequest =
        id && endpoint
          ? axios(`${endpoint}/${id}?presupuesto=true`)
          : Promise.reject(new Error('Proporcionar id o source al cargar datos de item'))

      doRequest.then(
        async (res) => {
          const currency = await BFFAgent.Datamasters.getCurrency(res.data.data.exchange_rate_id)
          const { defaultCurrency, symbol, multiplier, actualSellValue, name } = currency
          let symbolDefault = "$"
          if(!defaultCurrency && license?.company?.localCurrencyID) {
            await BFFAgent.Datamasters.getDefaultCurrency().then(
              response => {
                if(response) {
                  if(response?.data?.data) {
                    symbolDefault = response.data.data[0].currency?.symbol || "$"
                  }
                }
              }
            )
          }

          // TODO: Refactor use of res.data.data and then()
          const factorMonedaLocal = multiplier * actualSellValue

          res.data.data.currency_symbol = defaultCurrency ? symbol : symbolDefault
          res.data.data.currencyName = name
          res.data.data.defaultCurrency = defaultCurrency
          res.data.data.totalSellValue = factorMonedaLocal
          res.data.data.foreingCurrencySymbol = symbol;

          const net_sale_price = Number(res.data.data.net_sale_price)
          const precio_lista = Number(res.data.data.precio_lista)
          const flete_alistaje = Number(res.data.data.flete_alistaje)
          const bonificacion = Number(res.data.data.bonificacion)
          const nuevo = res.data.data.nuevo
          let bonifications = res.data.data.bonification
          let profileDiscounts = user.discounts

          if(!datos_frizados){
            res.data.data.net_sale_price = net_sale_price * factorMonedaLocal
            res.data.data.precio_lista = precio_lista * factorMonedaLocal
            res.data.data.bonificacion = bonificacion * factorMonedaLocal
            res.data.data.flete_alistaje = nuevo ? flete_alistaje * factorMonedaLocal : flete_alistaje

            if(res.data.data.accessory_1) {
              res.data.data.accessory_1 *= factorMonedaLocal
            }
            if(res.data.data.accessory_2) {
              res.data.data.accessory_2 *= factorMonedaLocal
            }
            if(presupuestador.selectedStock) {
              const stockBonification = res.data.data.Stocks.find(stock => (stock.id === presupuestador.selectedStock) && stock.Bonification.id)?.Bonification
              if (stockBonification){
                bonifications =  { ...res.data.data.bonification              
                                    , specific_selected_operator: stockBonification.specific_selected_operator
                                    , specific_amount: stockBonification.specific_amount
                                    , specific_percentage: stockBonification.specific_percentage
                                    , specific_valid_to: stockBonification.specific_valid_to
                                    , stock_comment: stockBonification.stock_comment
                                    , specific_discount_detail: stockBonification.specific_discount_detail
                                    , reminder: stockBonification.reminder }
              }
            }
            if(!res.data.data.nuevo) {
              if (res.data.data.bonification) {
                bonifications = res.data.data.bonification
              } else {
                bonifications = res.data.data.Stocks[0]?.Bonification
              }
            }
          }else{
            res.data.data.precio_lista = presupuestador.catalog_price_list
            res.data.data.flete_alistaje = presupuestador.catalog_flete_alistaje
            res.data.data.bonificacion = presupuestador.catalog_bonificacion_fabrica
            res.data.data.accessory_1 = presupuestador.catalog_accessory_1
            res.data.data.accessory_2 = presupuestador.catalog_accessory_2
            res.data.data.net_sale_price = presupuestador.catalog_net_sale_price

            bonifications = presupuestador.Bonifications || {}
            // Se setean en null los valid to para las bonificaciones frezadas
            bonifications.specific_valid_to = null
            bonifications.discount_valid_to = null
            bonifications.ranks_valid_to = null
            bonifications.taking_car_valid_to = null
            bonifications.car_lot_valid_to = null

            for (let i = 0; i < res?.data?.data?.Stocks?.length; i++) {
              if (res.data.data.Stocks[i].id === presupuestador.selectedStock) {
                if(presupuestador.createdAt <= res.data.data.Stocks[i].Bonification.specific_valid_to ){
                  res.data.data.Stocks[i].Bonification.specific_valid_to = null
                }
              }
              
            }
            profileDiscounts = [{
              id: presupuestador.Role_bonifications?.role_id || null,
              car_lot_id: presupuestador.Role_bonifications?.role_car_lot_id || null,
              sale_type: presupuestador.Role_bonifications?.role_sale_type || null,
              value: presupuestador.Role_bonifications?.role_value || null
            }]
           
            if(presupuestador.factor_moneda_local !== 1){
              res.data.data.defaultCurrency = false
              res.data.data.currencyName = presupuestador.catalog_currencyName
              res.data.data.currency_symbol = presupuestador.catalog_currency_symbol
              res.data.data.totalSellValue = presupuestador.factor_moneda_local
            }else{
              res.data.data.defaultCurrency = true
            }
          }

          if(presupuestador.tipoVentaSelected === "venta_directa") {
            bonifications = { ...bonifications, car_lot_amount_friz: bonifications?.car_lot_amount, car_lot_amount: null }
          }
          let dataAux = {
            nuevo: {
              ...res.data.data,
              branch_office_id: presupuestador?.branch_office_id,
              branch_office_name: presupuestador?.branch_office_name,
              bonification: bonifications,
            },
            profileDiscounts
          }
          // Controlo si es un presupuesto preguardado con una bonificación de vendedor
          if(presupuestador.special_discount){
            dataAux = {
              ...dataAux,
              special_discount: presupuestador.special_discount
            }
          }
          // Control si hay stock Seleccionado
          if(presupuestador.selectedStock){
            dataAux = {
              ...dataAux,
              selectedStock: presupuestador.selectedStock,
            }
          }
          dispatch({
            type: PRESUPUESTADOR_LOAD_ITEM_NUEVO_SUCCESS,
            data: dataAux,
            entregaUsados: presupuestador.entregaUsados,
          })
          resolve({
            ...res.data.data,
            branch_office_id: presupuestador?.branch_office_id,
            branch_office_name: presupuestador?.branch_office_name
          })
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: PRESUPUESTADOR_LOAD_ITEM_NUEVO_FAILURE,
            data: { error: err },
            entregaUsados: presupuestador.entregaUsados
          })
          reject(err)
        },
      )
    })

    return promise
  }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissLoadItemNuevoError() {
  return {
    type: PRESUPUESTADOR_LOAD_ITEM_NUEVO_DISMISS_ERROR,
  }
}

function getTipoVenta(auto, state) {
  if (auto.venta_directa && !auto.venta_convencional) {
    return 'venta_directa'
  }
  if (!auto.venta_directa && auto.venta_convencional) {
    return 'venta_convencional'
  }
  if (auto.venta_directa && auto.venta_convencional) {
    const validTipoVenta =
      auto[state.tipoVentaSelected] &&
      (state.tipoVentaSelected === 'venta_directa' || state.tipoVentaSelected === 'venta_convencional')
    return validTipoVenta ? state.tipoVentaSelected : 'venta_convencional'
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_LOAD_ITEM_NUEVO_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        loadItemNuevoPending: true,
        loadItemNuevoError: null,
      }

    case PRESUPUESTADOR_LOAD_ITEM_NUEVO_SUCCESS: {
      // The request is success
      const nuevo = action.data.nuevo
      nuevo.resale_price_increase = state.resale_price_increase
      let selectedStock = action.data.nuevo.Stocks.find(({id}) => id === action.data.selectedStock)
      if(!action.data.nuevo.nuevo){
        // Si es usado, asigno el único stock que tiene
        if(action.data.nuevo.Stocks.length > 0){
          selectedStock = action.data.nuevo.Stocks[0]
        }
      }
      if(action.data.special_discount){
        if(selectedStock){
          return {
            ...state,
            loadItemNuevoPending: false,
            loadItemNuevoError: null,
            nuevo,
            selectedStock: selectedStock.id,
            tipoVentaSelected: getTipoVenta(nuevo, state),
            special_discount: action.data.special_discount,
            entregaUsados: action.entregaUsados,
            profileDiscounts: action.data.profileDiscounts,
            integration_car_lot_id: action.data.integration_car_lot_id,
            integration_branch_office_id: action.data.integration_branch_office_id
          }
        }
        else{
          return {
            ...state,
            loadItemNuevoPending: false,
            loadItemNuevoError: null,
            nuevo,
            selectedStock: undefined,
            stock_id: null,
            stock_color: null,
            stock_ubicacion: null,
            stock_vin:  null,
            stock_sucursal:  null,
            stock_estado: null,
            tipoVentaSelected: getTipoVenta(nuevo, state),
            special_discount: action.data.special_discount,
            entregaUsados: action.entregaUsados,
            profileDiscounts: action.data.profileDiscounts,
            integration_car_lot_id: action.data.integration_car_lot_id,
            integration_branch_office_id: action.data.integration_branch_office_id
          }
        }        
      } else {
        return {
          ...state,
          loadItemNuevoPending: false,
          loadItemNuevoError: null,
          nuevo,
          selectedStock: selectedStock ? selectedStock.id : undefined,
          tipoVentaSelected: getTipoVenta(nuevo, state),
          entregaUsados: action.entregaUsados,
          profileDiscounts: action.data.profileDiscounts,
          integration_car_lot_id: action.data.integration_car_lot_id ? action.data.integration_car_lot_id : null,
          integration_branch_office_id: action.data.integration_branch_office_id ? action.data.integration_branch_office_id : null
        }
      }
    }

    case PRESUPUESTADOR_LOAD_ITEM_NUEVO_FAILURE:
      // The request is failed
      return {
        ...state,
        loadItemNuevoPending: false,
        loadItemNuevoError: action.data.error,
        entregaUsados: action.entregaUsados
      }

    case PRESUPUESTADOR_LOAD_ITEM_NUEVO_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        loadItemNuevoError: null,
      }

    default:
      return state
  }
}
